const strPadStart = (value, count = 6, symbol = '0') => {
  if (!value) return '';
  const str = value.toString();
  return str.padStart(count, symbol);
};

export default strPadStart;
